import { AccountCircleOutlined, MailOutlineRounded } from '@mui/icons-material'
import bg from '../assets/pattern.png';
import * as React from 'react'
import { SubmitHandler, useForm } from 'react-hook-form';
import { Button } from '@mui/material';
import {  setProfile} from '../features/usersSlice'
import { useSelector } from 'react-redux';
import { RootState } from '../app/store';
import { useDispatch } from 'react-redux';

type Inputs = {
	username: string,
	fullname: string,
	email: String,
};

export default function Settings () {
	let { profile: { fullname, username, email } } = useSelector((state: RootState) => state.user);
	const dispatch = useDispatch()
	const { register, handleSubmit, formState: { errors } } = useForm<Inputs>();
	const onSubmit: SubmitHandler<Inputs> = data => {
		dispatch(setProfile(data));
	};
	return (
		<>
			<img src={bg} alt="Background" className='h-52 w-full object-cover' />
			<div className='bg-["../assets/profilebg.jpg"]'></div>
			<h3 className='text-center text-xl mt-4 font-serif'>{fullname}</h3>
			<p className='text-center text-sm'>@{username}</p>
			<form onSubmit={handleSubmit(onSubmit)} className='px-4 py-6 text-sm my-4 border-t dark:border-gray-600'>
				<div className="flex">
					<AccountCircleOutlined className='mt-2' fontSize="small" />
					<div className='w-full ml-4'>
						<input defaultValue={username.toString()} {...register("username", { required: true })} className=' p-2 border w-full rounded outline-none dark:bg-slate-600 dark:border-slate-500' />
						{errors.username && <small className='text-red-400'>Username field is required</small>}
					</div>
				</div>
				<div className="flex my-4">
					<MailOutlineRounded className='mt-2' fontSize="small" />
					<div className='w-full ml-4'>
						<input defaultValue={email.toString()}  {...register("email", { required: true, pattern: /\S+@\S+\.\S+/ })} className=' p-2 border w-full rounded outline-none dark:bg-slate-600 dark:border-slate-500' />
						{errors.email && <small className='text-red-400'>Enter a valid email</small>}
					</div>
				</div>
				<div className="flex mb-4">
					<AccountCircleOutlined className='mt-2' fontSize="small" />
					<div className='w-full ml-4'>
						<input defaultValue={fullname.toString()}  {...register("fullname", { required: true })} className=' p-2 border w-full rounded outline-none dark:bg-slate-600 dark:border-slate-500' />
						{errors.fullname && <small className='text-red-400'>Fullname field is required</small>}
					</div>
				</div>
				<Button onClick={handleSubmit(onSubmit)} size='small' className='float-right' variant='contained'>Save</Button>
			</form>
		</>
	)
}
